import { render, staticRenderFns } from "./CollectionResidentBalanceInfo.vue?vue&type=template&id=79c06d0c&scoped=true&"
import script from "./CollectionResidentBalanceInfo.vue?vue&type=script&lang=ts&"
export * from "./CollectionResidentBalanceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionResidentBalanceInfo.vue?vue&type=style&index=0&id=79c06d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c06d0c",
  null
  
)

export default component.exports